// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.default-cursor[data-v-2870b737] {\n  cursor: auto !important;\n}\n.disabled[data-v-2870b737] {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
